<template>
  <div class="combobox-processing-item-error-display pointer-events-auto">
    <PAlert
      class="mr-2"
      :type="modelValue.weight === ExceptionWeights.ERROR ? AlertTypes.ERROR : AlertTypes.WARNING"
      :title="modelValue.getTitle()"
      :description="modelValue.getMessage()"
      :actions="
        modelValue.weight === ExceptionWeights.WARNING
          ? [{ label: 'Melding sluiten', onClick: () => emit('clearError') }]
          : []
      "
    />
  </div>
</template>

<script setup lang="ts">
import { ExceptionWeights } from "@/enums/exceptions/exception-weights"
import { AlertTypes } from "@/interfaces/component/alert.interface"
import PAlert from "@/components/elements/PAlert.vue"
import type { BaseException } from "@/exceptions/base-exception.exception"

const modelValue = defineModel<BaseException>({ required: true })

const emit = defineEmits(["clearError"])
</script>

<style scoped></style>
